import { Grid, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import {
  consumableSupply_unit,
  consumableSupply_pack,
  consumableSupply_rolls,
} from '../../../../../../../data/forms/nrc/consumableSupplyDropdownOptions.js';

export default function CaliforniaSupplySelectForm({
  supplySelections,
  setForm,
}) {
  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prevForm => ({
      ...prevForm,
      supplySelections: {
        ...prevForm.supplySelections,
        [name]: value,
      },
    }));
  };

  return (
    <>
      <Grid size={6}>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Adjustment Forms'}</InputLabel>
          <Select
            value={supplySelections.adjustmentForms}
            label={'Adjustment Forms'}
            onChange={handleChange}
            name='adjustmentForms'
          >
            {consumableSupply_unit.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Claim Forms'}</InputLabel>
          <Select
            value={supplySelections.claimForms}
            label={'Claim Forms'}
            onChange={handleChange}
            name='claimForms'
          >
            {consumableSupply_unit.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Daily 3 Playslip'}</InputLabel>
          <Select
            value={supplySelections.daily3}
            label={'Daily 3 Playslip'}
            onChange={handleChange}
            name='daily3'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Daily 4 Playslip'}</InputLabel>
          <Select
            value={supplySelections.daily4}
            label={'Daily 4 Playslip'}
            onChange={handleChange}
            name='daily4'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Daily Derby Playslip'}</InputLabel>
          <Select
            value={supplySelections.dailyDerby}
            label={'Daily Derby Playslip'}
            onChange={handleChange}
            name='dailyDerby'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Fantasy 5 Playslip'}</InputLabel>
          <Select
            value={supplySelections.fantasy5}
            label={'Fantasy 5 Playslip'}
            onChange={handleChange}
            name='fantasy5'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Hot Spot Playslip'}</InputLabel>
          <Select
            value={supplySelections.hotSpot}
            label={'Hot Spot Playslip'}
            onChange={handleChange}
            name='hotSpot'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid size={6}>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'ITVM Rolls'}</InputLabel>
          <Select
            value={supplySelections.itvmRolls}
            label={'ITVM Rolls'}
            onChange={handleChange}
            name='itvmRolls'
          >
            {consumableSupply_rolls.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Mega Millions Playslip'}</InputLabel>
          <Select
            value={supplySelections.megaMillions}
            label={'Mega Millions Playslip'}
            onChange={handleChange}
            name='megaMillions'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Perforated Tape'}</InputLabel>
          <Select
            value={supplySelections.perforatedTape}
            label={'Perforated Tape'}
            onChange={handleChange}
            name='perforatedTape'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Powerball Playslip'}</InputLabel>
          <Select
            value={supplySelections.powerball}
            label={'Powerball Playslip'}
            onChange={handleChange}
            name='powerball'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Super Lotto Plus Playslip'}</InputLabel>
          <Select
            value={supplySelections.superLottoPlus}
            label={'Super Lotto Plus Playslip'}
            onChange={handleChange}
            name='superLottoPlus'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Ticket Stock (Printer Paper)'}</InputLabel>
          <Select
            value={supplySelections.ticketStock}
            label={'Ticket Stock (Printer Paper)'}
            onChange={handleChange}
            name='ticketStock'
          >
            {consumableSupply_rolls.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </>
  );
}
